import { render, staticRenderFns } from "./TableComplaintSelected.vue?vue&type=template&id=724df7f6&scoped=true"
import script from "./TableComplaintSelected.vue?vue&type=script&lang=js"
export * from "./TableComplaintSelected.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724df7f6",
  null
  
)

export default component.exports